enum WorkflowActionNames {
  TRANSITION_BY_STATE_FROM_INDEX = 'transitionByStateFromIndex',
}

export default WorkflowActionNames;
